import { render } from "./PerformanceStatusBar.vue?vue&type=template&id=e754827e&scoped=true"
import script from "./PerformanceStatusBar.vue?vue&type=script&lang=js"
export * from "./PerformanceStatusBar.vue?vue&type=script&lang=js"

import "./PerformanceStatusBar.vue?vue&type=style&index=0&id=e754827e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e754827e"]])

export default __exports__